import * as React from "react";
import CardSummary from "../../../../../../../modules/PaymentMethodsList/Payments/Adyen/AdyenPaymentCard/AdyenPaymentCardSummary.js";
const BancontactSummary = (props) => /* @__PURE__ */ React.createElement(CardSummary, { ...props });
export {
  BancontactSummary as default
};
//# sourceMappingURL=BancontactSummary.js.map
